import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithBoxLockScreen() {
	return <AuthShell variant="with-box"><AuthForm variant="with-box" mode="lock-screen" /></AuthShell>;
}

export default AuthWithBoxLockScreen;
